var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4166 4.27108C16.1844 5.55903 17.3333 7.6453 17.3333 9.99992C17.3333 13.9119 14.162 17.0833 10.25 17.0833H9.83329M6.08329 15.7288C4.31551 14.4408 3.16663 12.3545 3.16663 9.99992C3.16663 6.0879 6.33794 2.91659 10.25 2.91659H10.6666M11.0833 18.6666L9.41663 16.9999L11.0833 15.3333M9.41663 4.66659L11.0833 2.99992L9.41663 1.33325",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.f9a5063203b0a3285f58218992ee9a8e.svg";
export { ForwardRef as ReactComponent };